import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
//import useDynamicInputs from "../hooks/useDynamicInputs";
//import useDynamicInputs from "hooks/useDynamicInputsAllSport";
import { generateRandomString } from "../services/util";
import useDynamicInputsAllSport from "hooks/useDynamicInputsAllSport";

const myDefault = 'ber';

interface SportsPrepend {
  name: string
  sport_type : string
  value?: string
}

interface AllSportsDropdownProps {
  selectedSports: string[]
  onChange(value: string[]): void
  multiple?: boolean
  prepend?: SportsPrepend[]
}

const AllSportsDropdown: React.FC<AllSportsDropdownProps> = ({prepend = [], selectedSports, multiple, onChange}) => {
  const {sports} = useDynamicInputsAllSport();
  //console.log("All Sport Data", sports);

  const getSportsOptions = () => {
    let options: React.ReactNode[] = [];
    let sports_prepended: any[] = [];
    sports_prepended = [...prepend.map((each: SportsPrepend) => {
      return each;
    }), ...sports];
    if (sports_prepended && sports_prepended.length > 0){
      if (sports_prepended.map !== undefined){
        options = sports_prepended.map((sport: SportsPrepend) => {
          return (
            <IonSelectOption
              key={generateRandomString()}
              value={sport.value ?? sport.name}
              
            >
              {sport.name} ({(sport.sport_type=='I' ? "Single" : 'Team')})
            </IonSelectOption>
          )
        });
      } else {
        return [];
      }
    }

    return (
      <IonSelect 
        multiple={multiple}
        //value={selectedSports}
        placeholder="Select Sports"
        onIonChange={e => onChange(e.detail.value)}
        interface="alert"
      >
        {options}
      </IonSelect>
    );
  }
  return (
    <IonItem>
      <div className="emaillab">
        <IonLabel position="stacked" style={{fontSize: '16px !important'}}>{(multiple) ? "Sports":"Sport"}</IonLabel>
      </div>
      {getSportsOptions()}
    </IonItem>
  );
}

export default AllSportsDropdown;